// /src/pages/public/ProjectDetail.tsx

import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import styles from "../../styles/ProjectDetail.module.css";
import { getProjectById } from "../../lib/firebase/firestore";
import { Project } from "../../types";

export const ProjectDetail = () => {
  const { id } = useParams<{ id: string }>();
  const [project, setProject] = useState<Project | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      if (!id) return;
      const data = await getProjectById(id);
      setProject(data);
      setLoading(false);
    };
    load();
  }, [id]);

  if (loading) return <div>Loading...</div>;
  if (!project) return <div>Project not found</div>;

  return (
    <div className={styles.detailContainer}>
      <Link to="/projects" className={styles.backLink}>
        ← Back to projects
      </Link>
      <br />
      <br />

      <div className={styles.coverImage}>
        <img src={project.coverImageUrl} alt={project.title} />
      </div>

      <div className={styles.content}>
        <h1>{project.title}</h1>
        <p className={styles.meta}>
          {project.year} • {project.tags.join(", ")}
        </p>

        {/* Render dynamic content sections */}
        {project.contentSections?.map((section, index) => (
          <div
            key={index}
            className={`${styles.section} ${
              styles[section.layout || "full-width"]
            }`}
          >
            {section.imageUrl && (
              <img
                src={section.imageUrl}
                alt={`Section ${index}`}
                className={styles.sectionImage}
              />
            )}
            {section.heading && <h2>{section.heading}</h2>}
            {section.text && <p>{section.text}</p>}
          </div>
        ))}
      </div>
    </div>
  );
};
